import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import {
  LucideAngularModule,
  ClipboardList,
  Loader2,
} from 'lucide-angular';
import { QuestionEditService } from '../question-edit.service';
import { ScoringGuideTableComponent } from '../../../../../grading-chat/components/scoring-guide-preview/components/scoring-guide-table/scoring-guide-table';

@Component({
  selector: 'app-rubric-content',
  standalone: true,
  imports: [CommonModule, LucideAngularModule, ScoringGuideTableComponent],
  templateUrl: './rubric-content.html',
  styleUrl: './rubric-content.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RubricContentComponent implements OnInit {
  protected readonly service = inject(QuestionEditService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly destroyRef = inject(DestroyRef);

  protected readonly icons = {
    ClipboardList,
    Loader2,
  };

  ngOnInit(): void {
    this.service.stateChanged$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.cdr.markForCheck());

    this.service.loadRubric();
  }
}
